export const Constants = {
  AccessTokenKey: 'rto-accessToken',
  LoginPage: 'https://accounts.shopify.com/store-login',
  MarkIsDevelopUser: 'rto-isDevelopUser',
  AppUrlInStore: 'https://apps.shopify.com/omnitrack-facebook-pixels',
  MobileLoginPage: '/mobile/phone-login',
};
